import React from 'react';
import { NavDropdown, Nav } from "react-bootstrap";
import { NavLink, useLocation } from 'react-router-dom';
import './TopNavbar.css';
import { useAuth } from '../../context/AuthContext';
import Cookies from 'js-cookie';

const routeLabels = {
    '/dashboard':        { label: 'Dashboard',        parent: null },
    '/registered-users': { label: 'Registered Users', parent: 'Users' },
    '/categories':       { label: 'Categories',       parent: 'Catalogue' },
    '/artists':          { label: 'Artists',           parent: 'Catalogue' },
    '/products':         { label: 'Products',          parent: 'Catalogue' },
    '/orders':           { label: 'Orders',            parent: 'Commerce' },
    '/subscriptions':    { label: 'Subscriptions',     parent: 'Commerce' },
    '/donations':        { label: 'Donations',         parent: 'Commerce' },
    '/contact-support':  { label: 'Contact Support',   parent: 'Support' },
};

const todayStr = new Date().toLocaleDateString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', year: 'numeric',
});

function TopNavbar() {
    const { logout } = useAuth();
    const location   = useLocation();
    const user       = JSON.parse(Cookies.get('artfroAdminUser') || '{}');
    const route      = routeLabels[location.pathname] || { label: 'Admin', parent: null };

    return (
        <div className="top-navbar">
            {/* Left — breadcrumb + page title */}
            <div className="top-nav-left">
                <div className="top-nav-breadcrumb">
                    <span>Artfro Admin</span>
                    {route.parent && (
                        <>
                            <i className="fa-solid fa-chevron-right sep" />
                            <span>{route.parent}</span>
                        </>
                    )}
                    <i className="fa-solid fa-chevron-right sep" />
                    <span>{route.label}</span>
                </div>
                <div className="top-nav-page">{route.label}</div>
            </div>

            {/* Right — date, notifications, profile */}
            <div className="top-nav-right">
                <div className="top-nav-date">
                    <i className="fa-regular fa-calendar" style={{ marginRight: 6 }} />
                    {todayStr}
                </div>

                <button className="top-nav-icon-btn" title="Notifications">
                    <i className="fa-regular fa-bell" />
                </button>

                <Nav>
                    <NavDropdown
                        id="profile-dropdown"
                        title={
                            <div className="profile-trigger">
                                <img
                                    src={require('../../assets/bussinessman.jpeg')}
                                    alt="profile"
                                    className="profile-avatar"
                                />
                                <span className="profile-name">{user.name || 'Admin'}</span>
                                <i className="fa-solid fa-chevron-down profile-chevron" />
                            </div>
                        }
                        align="end"
                    >
                        <div className="dropdown-user-header">
                            <div className="dropdown-user-name">{user.name || 'Admin'}</div>
                            <div className="dropdown-user-email">{user.email || ''}</div>
                        </div>

                        <NavDropdown.Item as="div" style={{ padding: 0 }}>
                            <NavLink to="/dashboard" className="dropdown-item-custom">
                                <i className="fa-solid fa-gauge-high" />
                                <span>Dashboard</span>
                            </NavLink>
                        </NavDropdown.Item>

                        <NavDropdown.Item as="div" style={{ padding: 0 }}>
                            <NavLink to="/" onClick={logout} className="dropdown-item-custom logout">
                                <i className="fa-solid fa-right-from-bracket" />
                                <span>Sign out</span>
                            </NavLink>
                        </NavDropdown.Item>
                    </NavDropdown>
                </Nav>
            </div>
        </div>
    );
}

export default TopNavbar;
